// extracted by mini-css-extract-plugin
export default {"prices":"PropertyStats_prices__-lg6e","price":"PropertyStats_price__QMMJr","pricePerSqft":"PropertyStats_pricePerSqft__l9br7","mainStats":"PropertyStats_mainStats__7Wcy8"};